import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import PropTypes from "prop-types";
import "../Search/Search.scss";
import { InputText } from "primereact/inputtext";
import { IoSendSharp } from "react-icons/io5";
import "../ActionSearch/ActionSearch.scss"


// PropTypes validation
ActionSearch.propTypes = {
  config: PropTypes.any.isRequired,
  setConfig: PropTypes.any.isRequired,
  performAction:PropTypes.any.isRequired,
  selectedFile:PropTypes.any.isRequired,
};

export default function ActionSearch({ config, setConfig ,performAction, selectedFile}) {
  const [form, setForm] = useState(config);
  const updateConfig = (field, value) => {
    const configValue = JSON.parse(JSON.stringify(form));
    configValue[field] = value;
    setForm(configValue);
  };

  const handleKeyDown=(e,data)=>{
    if (e.key === "Enter" ) {
      console.log(data);
      performAction(data);
    }
  }



  return (
    <div className="search-header">
      <div className="form-group">
        <div className="search">
        <label>Action </label>
        <Dropdown
        className="dropdown"
          value={form.action}
          onChange={(e) => updateConfig("action", e.value)}
          options={["REFACTOR","ANAYLSIS","REVIEW"]}
          defaultValue={"ANALYSIS"}
          placeholder="Select Action"
        />
        <InputText
         placeholder="Ask Peer AI..."
         value={config.searchKeys}
         onKeyDown={(e)=>{
          const updatedConfig = {
            ...config,
            files: Array.isArray(selectedFile)?selectedFile:[selectedFile]
          };
          handleKeyDown(e,updatedConfig)
         }}
         onChange={(e) =>
           setConfig({ ...config, searchKeys: e.target.value })
         }/>
        <IoSendSharp size={30} style={{cursor:"pointer"}} onClick={()=>{
          // console.log(selectedFile);
          
            const updatedConfig = {
                ...config,
                files: Array.isArray(selectedFile)?selectedFile:[selectedFile]
              };
              setConfig(updatedConfig);
              performAction(updatedConfig)
        }}/>
        </div>
      </div>

    </div>
  );
}
